import React, { PropsWithChildren } from 'react';
import Modal, { ModalButton } from '.';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface Props extends PropsWithChildren {
  title?: string;
  actions: ModalButton[];
  onClose: () => void;
}

const ActionModal: React.FC<Props> = ({
  title,
  actions,
  onClose,
  children,
}) => {
  return (
    <Modal
      buttons={actions}
      closeOnOutsideClick={false}
      onClose={onClose}
      title={title}
    >
      <Wrapper>{children}</Wrapper>
    </Modal>
  );
};

export default ActionModal;
